import React from 'react'
import './services.css'
import TextScrambler from 'react-scramble-text'
import 'react-scramble-text/dist/index.css'

const Services = () => {
  const phrases = ["{Services}", "{Services} "]
  return (
    <section id="services">
      <h5>What We Offer</h5>
      <h2><TextScrambler phrases={phrases} speed={5} pauseTime={1000}/></h2>

      <div className="container service__container">
        <article className="service">
          <div className="service_head">
            <h3>Custom Scripts</h3>
          </div>

          <ul className="service__list">
            <li className='li'>
              <p>We can provide you with all opportunities to create the best script for you with high quality.</p>
            </li>
            <li className='li'>
              <p>Available frameworks [ESX,QBCORE,STANDALONE]</p>
            </li>
            <li className='li'>
              <p>If you have an idea you can tell us it and we will make it for you.</p>
            </li>
          </ul>
        </article>
        {/* END OF THE FIRST */}
        <article className="service">
          <div className="service_head">
            <h3>Servers development service</h3>
          </div>

          <ul className="service__list">
            <li className='li'>
              <p>We can make a custom server from the scratch for you.</p>
            </li>
            <li className='li'>
              <p>We can optimize/fix all your server resources.</p>
            </li>
          </ul>
        </article>
        {/* END OF THE SECOND */}
        <article className="service">
          <div className="service_head">
            <h3>24/7 support for our customers</h3>
          </div>

          <ul className="service__list">
            <li className='li'>
              <p>When you become one of our customers, we will give you a 24/7 support service to help you.</p>
            </li>
          </ul>
        </article>
        {/* END OF THE SECOND */}
      </div>
    </section>
  )
}

export default Services